import React from 'react';
import { Routes, Route } from 'react-router-dom';
import InsuranceDashboard from '../components/insurance/InsuranceDashboard';
import DisputeForm from '../components/insurance/DisputeForm';
import ProtectedRoute from '../components/auth/ProtectedRoute';

const InsurancePage = () => {
  return (
    <ProtectedRoute requiredPermission="disputes.read">
      <Routes>
        <Route index element={<InsuranceDashboard />} />
        <Route 
          path="dispute/new" 
          element={
            <ProtectedRoute requiredPermission="disputes.create">
              <DisputeForm />
            </ProtectedRoute>
          } 
        />
      </Routes>
    </ProtectedRoute>
  );
};

export default InsurancePage;